import { Sigil } from "./Sigil";
import { CONTACT_EMAIL } from "@/data/temple";
import { scrollToId } from "@/lib/scroll";
import MoonPhase from "./MoonPhase";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden pt-24 pb-10">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div className="max-w-md">
            <Sigil className="w-14 h-14" width={2.5} />
            <p className="font-display italic text-2xl mt-6 leading-snug">
              Breath by breath, Gate by Gate, wave by wave — until your very presence becomes the transmission.
            </p>
            <p className="font-tt-mono text-[12px] uppercase tracking-[0.3em] text-[#D9B47A] mt-4">Blessed Be.</p>
          </div>
          <div className="flex flex-col gap-3 text-sm text-[#CFC2B6]">
            {[["gates", "The 13 Gates"], ["matrix", "The Orgasm Matrix"], ["books", "The Books"], ["workshop", "The Workshop"]].map(([id, l]) => (
              <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="text-left hover:text-[#D9B47A] transition-colors">
                {l}
              </button>
            ))}
            <a data-testid="footer-email" href={`mailto:${CONTACT_EMAIL}`} className="hover:text-[#D9B47A] transition-colors">{CONTACT_EMAIL}</a>
          </div>
        </div>
        <p aria-hidden="true" className="font-display text-[clamp(3rem,13.5vw,15rem)] leading-[0.85] tracking-[-0.03em] mt-20 text-[#F2E8DF]/[0.07] whitespace-nowrap select-none">
          The Tantric <em>Temple</em>
        </p>
        <div className="hairline mt-6" />
        <div className="mt-6 flex flex-col lg:flex-row lg:items-center justify-between gap-4 font-tt-mono text-[12px] uppercase tracking-[0.2em] text-[#A8998C]">
          <span data-testid="footer-copyright">© {year} Amy-Renee Hovorka · The Tantric Temple</span>
          <MoonPhase />
          <span>Practise with consent · Practise with reverence</span>
        </div>
      </div>
    </footer>
  );
}
